import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  // Request permission for Firebase notifications
  requestPer(): void {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebaseConfig.vapidKey })
      .then((currentToken: any) => {
        if (currentToken) {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('fcmToken', currentToken);
          }
        } else {
          alert(this.translate.instant('common.fcmNotification'));
        }
      })
      .catch(() => {
        // console.log('An error occurred while retrieving token. ', err);
      });
  }

  listenForFrontMessages(): void {
    const messaging = getMessaging();
    onMessage(messaging, (payload: any) => {
      const message = payload;
      if (message.notification) {
        const notificationOptions = {
          body: message.notification.body || '',
          icon: '',
          data: message
        };
        // Display notification using service worker
        this.displayNotification(
          message.notification.title || '',
          notificationOptions
        );
      }
    });
  }
  private displayNotification(
    title: string,
    options: NotificationOptions
  ): void {
    // Check for service worker registration
    navigator.serviceWorker
      .getRegistration('/firebase-cloud-messaging-push-scope')
      .then(registration => {
        if (registration) {
          // Show notification
          registration.showNotification(title, options);
        } else {
          console.error('Service worker registration not found.');
        }
      });
  }

}
